import { render, staticRenderFns } from "./ReturnPaymentPlanRecordsDetails.vue?vue&type=template&id=0f881ce4"
import script from "./ReturnPaymentPlanRecordsDetails.vue?vue&type=script&lang=js"
export * from "./ReturnPaymentPlanRecordsDetails.vue?vue&type=script&lang=js"
import style0 from "./ReturnPaymentPlanRecordsDetails.vue?vue&type=style&index=0&id=0f881ce4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports